import { cn } from '@/lib/utils';

type PractitionerNameWithCategoryProps = {
    firstName?: string | null;
    lastName?: string | null;
    title?: string | null;
    name?: string | null;
    categoryName?: string | null;
    className?: string;
};

export function PractitionerNameWithCategory({
    firstName,
    lastName,
    title,
    name,
    categoryName,
    className,
}: PractitionerNameWithCategoryProps) {
    const displayName = name?.trim() || [title, firstName, lastName].filter(Boolean).join(' ');

    return (
        <span className={cn('inline-flex items-baseline gap-1 min-w-0', className)}>
            <span className="truncate">{displayName}</span>
            {categoryName ? (
                <span className="text-[10px] leading-none text-muted-foreground shrink-0">
                    {categoryName}
                </span>
            ) : null}
        </span>
    );
}
